import { motion } from 'framer-motion';

export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden bg-omnio-black pt-20">
      {/* Background subtle gradient */ }
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-gradient-to-b from-omnio-charcoal/20 to-omnio-black" />
        <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-omnio-charcoal/30 blur-[120px] rounded-full pointer-events-none" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
          className="space-y-8"
        >
          <h1 className="text-5xl md:text-7xl font-bold text-omnio-white tracking-tight leading-tight">
            Not just an app. <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-omnio-white via-omnio-silver to-omnio-gray">
              A Living System.
            </span>
          </h1>
          
          <p className="max-w-2xl mx-auto text-xl text-omnio-silver font-light leading-relaxed">
            Omnio learns, adapts, and evolves with you. A holistic approach combining workouts, 
            nutrition, mental wellness, and daily habits to help you build unshakeable discipline.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-8">
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-omnio-white text-omnio-black rounded-full font-medium text-lg hover:bg-omnio-light transition-colors w-full sm:w-auto shadow-[0_0_20px_rgba(255,255,255,0.1)]"
            >
              Start the Onboarding
            </motion.button>
            <motion.button 
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              className="px-8 py-4 bg-transparent border border-omnio-charcoal text-omnio-white rounded-full font-medium text-lg hover:border-omnio-silver transition-colors w-full sm:w-auto"
            >
              Explore the System
            </motion.button>
          </div>
        </motion.div>

        {/* Dashboard/Interface Mockup Abstract representation */}
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
          className="mt-20 mx-auto max-w-5xl relative"
        >
          <div className="aspect-[16/9] bg-omnio-dark border border-omnio-charcoal rounded-2xl shadow-2xl overflow-hidden relative">
            <div className="absolute inset-0 bg-gradient-to-br from-omnio-white/5 to-transparent pointer-events-none" />
            <div className="absolute top-0 left-0 right-0 h-12 border-b border-omnio-charcoal flex items-center px-6 gap-2">
              <div className="w-3 h-3 rounded-full bg-omnio-charcoal"></div>
              <div className="w-3 h-3 rounded-full bg-omnio-charcoal"></div>
              <div className="w-3 h-3 rounded-full bg-omnio-charcoal"></div>
            </div>
            <div className="p-8 pt-20 h-full flex flex-col justify-center items-center text-omnio-gray">
              <span className="text-2xl font-light tracking-widest uppercase mb-4 text-omnio-silver">Meet Tedd</span>
              <p className="max-w-md text-center text-sm">"A healthy lifestyle is a blend of right food, correct workouts, ample sleep and most importantly mental well being. Let's make you win."</p>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
